import { LocalVoiceFilters, VoiceFiltersEnum } from '@/hooks/useFilteredVoices';
import styled from '@emotion/styled';
import { AgeChipSelect } from './AgeChipSelect';
import { FunctionChipMultiSelect } from './FunctionChipMultiSelect';
import { GenderChipSelect } from './GenderChipSelect';
import { LanguageChipSelect } from './LanguageChipSelect';
import { ProviderChipMultiSelect } from './ProviderChipMultiSelect';
import { ResetButton } from './ResetButton';
import { SearchField } from './SearchField';
import { TierChipSelect } from './TierChipSelect';
import { UseCaseChipSelect } from './UseCaseChipSelect';

const Wrapper = styled.div`
    margin-bottom: 8px;
`;

const FiltersContainer = styled.div`
    display: flex;
    margin-bottom: 8px;
    gap: 8px;
    overflow-x: auto;
    flex-wrap: nowrap;

    scroll-behavior: smooth;

    &::-webkit-scrollbar {
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.3);
    }
`;

interface Props {
    hiddenFilters?: VoiceFiltersEnum[];
    filters?: LocalVoiceFilters;
}

export const FiltersSection = ({ hiddenFilters, filters }: Props) => {
    const hiddenFiltersSet = new Set(hiddenFilters);

    return (
        <Wrapper>
            <SearchField />

            <FiltersContainer>
                {!hiddenFiltersSet.has(VoiceFiltersEnum.LANGUAGE) && <LanguageChipSelect />}
                {!hiddenFiltersSet.has(VoiceFiltersEnum.GENDER) && <GenderChipSelect />}
                {!hiddenFiltersSet.has(VoiceFiltersEnum.AGE) && <AgeChipSelect />}
                {!hiddenFiltersSet.has(VoiceFiltersEnum.USE_CASE) && <UseCaseChipSelect />}
                {!hiddenFiltersSet.has(VoiceFiltersEnum.TIER) && <TierChipSelect />}
                {!hiddenFiltersSet.has(VoiceFiltersEnum.VOICE_FUNCTION) && <FunctionChipMultiSelect />}
                {!hiddenFiltersSet.has(VoiceFiltersEnum.PROVIDERS) && <ProviderChipMultiSelect localProviders={filters?.providers} />}

                <ResetButton />
            </FiltersContainer>
        </Wrapper>
    );
};
